export default "__VITE_ASSET__BxMXCJ06__"